module.exports = __webpack_public_path__ + "static/favicon-626b1ec6479cf3dcd588ed14c55d2c8b.ico";